import React from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import RaisedButton from 'material-ui/RaisedButton';
import { addNotification } from 'actions/notifications/notifications';

import { execute } from 'store/configureStore';
import { getLetter } from 'sagas/letters';
import * as sagaTrain from 'sagas/train';
import * as sagaLetters from 'sagas/lettersNew';
import * as sagaAnnotations from 'sagas/annotations';

import TextEditor from './Management/TextEditor';
import HtmlContent from '../HtmlContent';

import AnnotationList from './List/Annotation';
import ErrorBoundary from './ErrorBoundary';

import ContentAnnotations from './Content/Annotations';

import Types from './Sidebar/Types';
import SenderTrain from './Sidebar/SenderTrain';

import { sendTrain } from 'actions/train';

class TrainPage extends React.Component {
    constructor(props) {
        super(props);

        let types = [];

        if (localStorage.getItem(`train${this.props.userId}`)) {
            types = JSON.parse(localStorage.getItem(
                `train${this.props.userId}`
            ));
        }

        this.state = {
            textLetter: '',
            annotations: [],
            selectedTextToTrain: '',
            types,
            selectedType: '',
        };

        this.updatePostAnnotations = this.updatePostAnnotations.bind(this);
        this.resendAnnotations = this.resendAnnotations.bind(this);

        this.changeSelectedTextToTrain = this.changeSelectedTextToTrain.bind(this);
        this.clearSelectedTextToTrain = this.clearSelectedTextToTrain.bind(this);

        this.addNewType = this.addNewType.bind(this);
        this.selectType = this.selectType.bind(this);

        this.sendTrain = this.sendTrain.bind(this);
        this.handleSendToDev = this.handleSendToDev.bind(this);
        this.handleOpenInDev = this.handleOpenInDev.bind(this);
    }

    sendTrain() {
        const { selectedTextToTrain, selectedType } = this.state;

        this.props.sendTrain({
            text: selectedTextToTrain,
            type: selectedType,
        });
    }

    async handleSendToDev() {
        try {
            await execute(sagaLetters.sendToDev, this.props.letter._id);
        } catch (error) {
            console.error(error);
        }
    }

    handleOpenInDev() {
        window.open(`http://anotatr.com:5001/${this.props.letter._id}/train`, '_blank');
    }

    selectType(e, i) {
        this.setState({
            selectedType: this.state.types[i],
        });
    }

    addNewType(type) {
        const types = this.state.types.slice();

        types.push(type);

        localStorage.setItem(
            `train${this.props.userId}`,
            JSON.stringify(types)
        );

        this.setState({
            types,
        });
    }

    clearSelectedTextToTrain() {
        this.setState({
            selectedTextToTrain: '',
        })
    }

    changeSelectedTextToTrain(text) {
        this.setState({
            selectedTextToTrain: this.state.selectedTextToTrain + text,
        })
    }

    resendAnnotations() {
        const { textLetter } = this.state;
        this.props.sendTrain({ text: textLetter });
    }

    updatePostAnnotations(textLetter) {
        this.setState({
            textLetter,
        }, () => {
            this.props.sendTrain({ text: textLetter });
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        let { textLetter } = this.state;

        if (textLetter === '' && nextProps.letter.text) {
            textLetter = nextProps.letter.text;
        }

        this.setState({
            textLetter,
            letter: nextProps.letter,
        });
    }

    async getData() {
        try {
            let { data: letter } = await execute(getLetter, this.props.routeParams.id);
            await execute(sagaLetters.sendToDev, { text: letter.text });
        } catch(error) {
            console.error(error);
        }
    }

    UNSAFE_componentWillMount() {
        this.getData();
    }

    render() {
        const {
            textLetter,
            typeAnnotations,
            selectedTextToTrain,
            selectedType,
            types,
        } = this.state;
        console.log(this.state);

        const { letter, train } = this.props;

        return (
            <div id='single-letter-gazetter' className='single-letter'>
                <div className='content'>
                    <div className='management'>
                        <div className='management-children' style={{ padding: '10px 0' }}>
                            <RaisedButton
                                className='btn'
                                label='Resend'
                                onClick={this.resendAnnotations}
                                labelStyle={{ fontSize: '10px' }}
                                style={{ height: '25px', margin: '0 10px 0 0' }}
                                buttonStyle={{ height: '25px', lineHeight: '25px' }}
                                primary
                            />

                            <ErrorBoundary>
                                <TextEditor
                                    textLetter={textLetter}
                                    typeAnnotations={typeAnnotations}
                                    updatePostAnnotations={this.updatePostAnnotations}
                                />
                            </ErrorBoundary>

                            <HtmlContent
                                letter={letter}
                            />
                            <RaisedButton
                                className='btn'
                                label='Send to dev-server'
                                onClick={this.handleSendToDev}
                                labelStyle={{ fontSize: '10px' }}
                                style={{ height: '25px', margin: '0 10px 0 0' }}
                                buttonStyle={{ height: '25px', lineHeight: '25px' }}
                                primary
                            />

                            <RaisedButton
                                className='btn'
                                label='Open in dev-server'
                                onClick={this.handleOpenInDev}
                                labelStyle={{ fontSize: '10px' }}
                                style={{ height: '25px', margin: '0 10px 0 0' }}
                                buttonStyle={{ height: '25px', lineHeight: '25px' }}
                                primary
                            />
                        </div>

                        <div className='subject'>SUBJECT: {letter.subject}</div>
                    </div>

                    <ErrorBoundary>
                        <ContentAnnotations
                            textLetter={textLetter}
                            changeSelectedTextToTrain={this.changeSelectedTextToTrain}
                        />
                    </ErrorBoundary>

                    <ErrorBoundary>
                        <AnnotationList />
                    </ErrorBoundary>
                </div>
                <div className='sidebar'>
                    <ErrorBoundary>
                        <Types
                            types={types}
                            selectedType={selectedType}
                            selectType={this.selectType}
                            addNewType={this.addNewType}
                        />
                    </ErrorBoundary>

                    <ErrorBoundary>
                        <SenderTrain
                            selectedTextToTrain={selectedTextToTrain}
                            selectedType={selectedType}
                            clearSelectedTextToTrain={this.clearSelectedTextToTrain}
                            sendTrain={this.sendTrain}
                        />
                    </ErrorBoundary>

                    <div className='paper-block margin-10'>
                        <span className='name-block absolute small-name'>Response train</span>
                        <p>
                            mailScore - {train.mailScore}
                        </p>

                        <p>
                            mailType - {train.mailType}
                        </p>

                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    ({ user: { user : { _id }, isLogged }, letter, train }) => {
        return {
            isLogged,
            userId: _id,
            letter,
            annotations: train.annotations,
            train,
        };
    },
    dispatch => ({ ...bindActionCreators({
            addNotification,
            sendTrain,
        }, dispatch), dispatch}),
)(TrainPage);



// WEBPACK FOOTER //
// ./app/components/Letters/Single/Train/Page.jsx